const SelectInput = ({ title, value, onChange, options, variant = "vertical", gap = "gap-2" }) => {
  return (
    <div className={variant === "vertical" ? "flex flex-col" : `flex flex-row items-center justify-center ${gap}`}>
      <label className="text-xs text-gray-600 mb-1 block">{title}</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-gray-300 rounded px-2 py-1 text-xs"
      >
        <option value="">Seleccionar</option>
        {options.map((option, i) => (
          <option key={option.id} value={option.id || option.value}>{option.name || option.label}</option>
        ))}
      </select>
    </div>
  )
}

export default SelectInput;